import React from 'react'
import { getPageLayoutType } from '../../../../common/utils/utilsFunc'
import GetCompensationPriv from '../CartolaCompAndRelPriv/CartolaCompensationPriv.js'
import { getPathName } from '../../../../common/utils/utilsFunc'
import CartolaReliquidationPriv from '../CartolaCompAndRelPriv/CartolaReliquidationPriv.js'
import ControllerCompAndRelPublic from '../ControllerCartolaCompAndRelPublic'

const ControllerCompensation = ({ titleCompensation,
  titleReliquidation,
  description,
  descripcioneCompensationPublic,
  descripcioneReliquidationPublic,
  configCartolaCompasationYears,
  textNoResults,
  textFetchError,
  textFetchNoId,
  textAlertFilledField,
  setGlobalAlert }) => {
  let pathName = getPathName()
  let actualYear = new Date().getFullYear();
  const listOptionReliquidation = [];
  const options = [
    {
      label: "(Seleccione año)",
      value: "",
    },
  ];
  let i = 0;
  while (i < Number(configCartolaCompasationYears) + 1) {
    options.push({
      label: (actualYear - i).toString(),
      value: (actualYear - i).toString(),
    });
    i++;
  }

  return (
    <div>
      {getPageLayoutType() && pathName === 'cartola-de-compensacion' &&
        <GetCompensationPriv
          titleCompensation={titleCompensation}
          description={description}
          options={options}
          textNoResults={textNoResults}
          textFetchError={textFetchError}
          textFetchNoId={textFetchNoId}
          textAlertFilledField={textAlertFilledField}
          setGlobalAlert={setGlobalAlert}
          pathName={pathName} />}

      {getPageLayoutType() && pathName === 'cartola-de-reliquidacion' &&
        <CartolaReliquidationPriv
          titleReliquidation={titleReliquidation}
          description={description}
          options={options}
          textNoResults={textNoResults}
          textFetchError={textFetchError}
          textFetchNoId={textFetchNoId}
          textAlertFilledField={textAlertFilledField}
          setGlobalAlert={setGlobalAlert}
          pathName={pathName} />}

      {!getPageLayoutType() && <ControllerCompAndRelPublic
        titleCompensation={titleCompensation}
        titleReliquidation={titleReliquidation}
        options={options}
        descripcioneCompensationPublic={descripcioneCompensationPublic}
        descripcioneReliquidationPublic={descripcioneReliquidationPublic}
        textNoResults={textNoResults}
        textFetchError={textFetchError}
        textAlertFilledField={textAlertFilledField}
        listOptionReliquidation={listOptionReliquidation}
        setGlobalAlert={setGlobalAlert}
      />}
    </div>
  )
}

export default ControllerCompensation
